/**
 * Minimal i18n shim for Phase 4 — Thai + English day-one (deviation D4).
 *
 * For v1 we use a static dictionary loaded on the server based on the
 * accept-language header (defaulting to `en`). No full i18n framework yet —
 * if the catalog grows beyond ~200 strings we swap to next-intl or tolgee.
 */

import en from "./locales/en.ts";
import th from "./locales/th.ts";

export type Locale = "en" | "th";
export type MessageKey = keyof typeof en;

const dictionaries: Record<Locale, Partial<Record<MessageKey, string>>> = { en, th };

export function t(locale: Locale, key: MessageKey): string {
  return dictionaries[locale][key] ?? dictionaries.en[key] ?? key;
}

export function detectLocale(acceptLanguage: string | null | undefined): Locale {
  if (!acceptLanguage) return "en";
  const lower = acceptLanguage.toLowerCase();
  if (lower.includes("th")) return "th";
  return "en";
}

export const SUPPORTED_LOCALES: readonly Locale[] = ["en", "th"];
